<template>
  <div class="container scrollable-div">
    <!-- 头部导航 -->
    <baseBack @font='font'></baseBack>
    <div class="pages" :style="containerStyle">
      <!-- 全真模拟的增加边框 border: 1px solid #c0c4cc -->
      <div style="padding-top: 1rem;width: 102rem;">
        <!-- 考生信息、题目、九宫格 -->
        <div style="background-color: #f0f0f0;display: flex;justify-content: space-between;">
          <!-- 考生信息、题目区 -->
          <div style="display: flex;flex-direction: column;width: 80rem;">
            <div style="min-height: 80%;display: flex;height: 80%;">
              <!-- 考生信息、倒计时 -->
              <div style="min-width: 20%;height: 25rem;overflow-y: auto;" class="scrollable-div">
                <!-- 考生信息 -->
                <div style="">
                  <div
                    style="text-align: center;position: relative;height: 5rem;border: 1px solid #8e8888;margin-top: 1rem;">
                    <span
                      style="position: absolute;top: -0.875rem;left:35%;color: #628dbb;width: 4.5rem;background-color: #f0f0f0;font-size: 1rem;">理论速成
                    </span>
                    <div class="u-font-30" style="line-height: 5rem;">第01号考台</div>
                  </div>
                  <div style="text-align: center;position: relative;border: 1px solid #8e8888;margin-top: 1.5rem;">
                    <span
                      style="position: absolute;top: -0.875rem;left:35%;color: #628dbb;width: 4.5rem;background-color: #f0f0f0;">考生信息
                    </span>
                    <div>
                      <div style="margin-top: 2.1rem;">
                        <img :src="config.systemLogo" style="width: 5rem;height: 5rem;" alt="" />
                      </div>
                      <div style="text-align: left;white-space: nowrap;margin: 1.3rem 0 0 3.25rem;">
                        <div class="flex">
                          <div>姓名：</div>
                          <div>奇顺交规</div>
                        </div>
                        <div class="flex">
                          <div>性别：</div>
                          <div>未知</div>
                        </div>
                        <div class="flex">
                          <div>类型：</div>
                          <div>{{CarTypeName}}</div>
                        </div>
                        <div class="flex" style="padding-bottom: 2rem;">
                          <div>科目：</div>
                          <div>{{ options.subject }}</div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <!-- 题目区 -->
              <div style="margin-left: 0.5rem;height: 25rem;width:55.8rem;">
                <div
                  style="position: relative;margin-top: 1rem;border: 1px solid #8e8888;height: 23.1rem;border-right: none;"
                  v-if="loaded">
                  <!-- 小标题浮动定位 -->
                  <span
                    style="position: absolute;top: -0.875rem;left:6%;color: #628dbb;width: 4.5rem;background-color: #f0f0f0;font-size: 1rem;">考试题目
                  </span>
                  <div class="flex scrollable-div"
                    style="height: 90%;overflow-y: auto;padding: 1rem 0 1rem 1rem;text-align: left;">
                    <div style="">
                      <!-- 类型：1单选题(蓝色)，2多选题(红色)，3判断题(黑色) -->
                      <div :class="{ flash, multiple }">
                        <!-- 类型：1单选题(蓝色)，2多选题(红色)，3判断题(黑色) -->
                        <div
                          :style="{color: `${currentQuestion.type === 3 ? '#000' : currentQuestion.type === 2 ? 'red' : currentQuestion.type === 1 ? 'blue' : ''}`}">
                          <div :class="'rich' + current" class="u-font-weight" v-html="currentQuestion.title"
                            :style="{fontSize: fontSize * 0.8 + 'px'}">
                          </div>

                          <div v-for="(item,index) in currentQuestion.options" :key="index" class="flex"
                            :style="{fontSize: fontSize * 0.8 + 'px'}" style="cursor:pointer;margin-top: 1.25rem;">
                            <div style="margin-right: 1.25rem;">
                              <div v-if="currentQuestion.type === 3" style="font-size: 1.875rem;font-weight: 600;">
                                {{ item.sort === 'A' ? '√' : '×' }}
                              </div>
                              <div v-else>
                                {{ item.sort }}
                              </div>
                            </div>
                            <div style="height: 2.5rem;line-height: 2.5rem;" v-html="item.content"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <audio id="successpay" autoplay="autoplay" />
                </div>
              </div>
            </div>
            <div style="min-height: 20%;display: flex;overflow-y: auto;height: 20%;">
              <!-- 时间倒计时 -->
              <div style="width: 13.4rem;position: relative;">
                <div style="text-align: center;border: 1px solid #8e8888;margin-top: 1rem;">
                  <span
                    style="position: absolute;top:0.3125rem;left:35%;color: #628dbb;width: 4.5rem;background-color: #f0f0f0;font-size: 1rem;">
                    {{options.txt === '模拟考试' ?'剩余时间':'考试时间'}}
                  </span>
                  <div style="height: 4.3rem;line-height: 4.3rem;font-size: 1.5rem;" v-if="options.txt === '模拟考试'">
                    <!-- 倒计时 -->
                    <BaseCountDown @end='berfor_complete' ref='CountDown'></BaseCountDown>
                  </div>
                  <div style="height: 4.3rem;line-height: 4.3rem;text-align: center;font-size: 1.5rem;" v-else>45:00
                  </div>
                </div>
              </div>
              <!-- 答案选择区 -->
              <div style="min-width: 75%;">
                <div style="font-weight: 600;padding-top: 1.3rem;">
                  <!-- 勾选显示答案 -->
                  <div v-if="isAnswers"
                    style="display: flex;justify-content: space-between;font-size: 1.8rem;color: red;">
                    <div style="padding: 0.625rem;"
                      v-if="currentQuestion.answer && isAnswers && (options.txt === '精选题库' || options.txt === '错题库')">
                      标准答案:{{ currentQuestion.answer }}
                    </div>
                    <div v-else style="display: flex;justify-content: space-between;font-size: 1.8rem;">
                      <div style="padding: 0.625rem;">
                        您的选择答案是：
                        <span v-if="currentQuestion.resultInfo">
                          <span v-if="currentQuestion.type === 3">
                            {{ currentQuestion.resultInfo.result === 'A' ? '√' : '×' }}
                          </span>
                          <span v-else>
                            {{ currentQuestion.resultInfo.result }}
                          </span>
                        </span>
                      </div>
                      <div style="font-weight: bold;margin-right: 1.25rem;display: flex;flex-direction: row">
                        <span v-for="(item, index) in currentQuestion.options" :key="index" @click="onCaskClick(index)"
                          class="selectblock" :class="item.selected ? 'changes' : ''">
                          <a v-if="currentQuestion.type === 3">{{ item.sort === 'A' ? '√' : '×' }}</a>
                          <a v-else>{{ item.sort }}</a>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- 未勾选显示答案 -->
                  <div v-else style="display: flex;justify-content: space-between;font-size: 1.8rem;">
                    <div style="padding: 0.625rem;">
                      您的选择答案是：
                      <span v-if="currentQuestion.resultInfo">
                        <span v-if="currentQuestion.type === 3">
                          {{ currentQuestion.resultInfo.result === 'A' ? '√' : '×' }}
                        </span>
                        <span v-else>
                          {{ currentQuestion.resultInfo.result }}
                        </span>
                      </span>
                    </div>
                    <div style="font-weight: bold;margin-right: 1.25rem;display: flex;flex-direction: row">
                      <span v-for="(item, index) in currentQuestion.options" :key="index" @click="onCaskClick(index)"
                        class="selectblock" :class="item.selected ? 'changes' : ''">
                        <a v-if="currentQuestion.type === 3">{{ item.sort === 'A' ? '√' : '×' }}</a>
                        <a v-else>{{ item.sort }}</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 九宫格 -->
          <div class="grid-container">
            <div class="grid-header">
              <div class="grid-cell header-cell title-cell">题目</div>
              <div class="grid-cell header-cell" v-for="col in 10" :key="col">{{ col }}列</div>
            </div>
            <div class="grid-body">
              <div class="grid-row" v-for="(row, rowIndex) in gridData" :key="rowIndex">
                <div class="grid-cell title-cell grid-border-bottom">{{ row.title }}</div>
                <div class="grid-cell hover-cell" :class="row[`col${colIndex}`]===undefined ? 'hide-content':''"
                  :style="{backgroundColor: current === row['col' + colIndex] ? '#0ad0be' : ''}" v-for="colIndex in 10"
                  :key="`${rowIndex}-${colIndex}`" @click="clickItems(row[`col${colIndex}`])">
                  <template v-if="list[row[`col${colIndex}`]]">
                    <div v-if="list[row[`col${colIndex}`]]['resultInfo']"
                      :class="list[row[`col${colIndex}`]]['resultInfo']['pass'] === 0? 'success' : list[row[`col${colIndex}`]]['resultInfo']['pass'] === 1 ? 'default' : ''"
                      :style="{
                             transform: getScaleTransform(list[row[`col${colIndex}`]]['resultInfo'])
                           }">
                      <span v-if="list[row[`col${colIndex}`]]['resultInfo']['type'] === 3">
                        {{ list[row[`col${colIndex}`]]['resultInfo']['result'] === 'A' ? '√' : '×' }}
                      </span>
                      <span v-else>
                        {{ list[row[`col${colIndex}`]]['resultInfo']['result'].replace(/,/g,'') }}
                      </span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!--              <div style="border: 1px solid gray;">
                <div style="overflow: auto;" class="scrollable-div">
                  <ul style="position: absolute;    margin-left: -40px;">
                    <li class="liBclo liBclo1">题目</li>
                    <li class="liBclo liBclo1" v-for="(j,index) in Math.ceil(list.length/10)" :key="index">
                      {{ j++ }}行
                    </li>
                  </ul>
                  <ul class="table scrollable-div">
                    <li class="liBclo">1列</li>
                    <li class="liBclo">2列</li>
                    <li class="liBclo">3列</li>
                    <li class="liBclo">4列</li>
                    <li class="liBclo">5列</li>
                    <li class="liBclo">6列</li>
                    <li class="liBclo">7列</li>
                    <li class="liBclo">8列</li>
                    <li class="liBclo">9列</li>
                    <li class="liBclo">10列</li>
                    <li v-for="(item,index) in list" :key="index" @click="current = index"
                       :style="{background: current === index ? '#0ad0be' : ''}" style="font-size: 5px;">
                       <p style="text-align: center;line-height: 45px;" v-if="item.resultInfo"
                         :class="item.resultInfo ? item.resultInfo.pass === 0? 'success' : item.resultInfo.pass === 1 ? 'default' : '' : ''">
                         <span v-if="item.type === 3" style="font-size: 1.8rem;">
                           {{ item.resultInfo.result === 'A' ? '√' : '×' }}
                         </span>
                         <span v-else :style="{
                             fontSize: item.resultInfo.resultArr.length >=3 ? '1rem' :
                                       item.resultInfo.resultArr.length > 2 ? '1.4rem' : '1.8rem'
                           }">
                           {{ item.resultInfo.result?item.resultInfo.result.replace(/,/g,''):item.resultInfo.result }}
                         </span>
                       </p>
                     </li>
                  </ul>
                </div>
              </div> -->
        </div>

        <!-- 操作条{{ item.resultInfo.result }} -->
        <div
          style="padding:1.5rem;border: 3px solid blue;border-left: 1px solid #8e8888;border-right: 1px solid #8e8888;"
          class="flex flex-col-center">
          <div class="u-flex-1.5">
            <div class="flex " style="align-items: center;">
              <div style="color: red;font-size: 20px;margin-right: 18px;">
                操作提示：{{ currentQuestion.typeStr }}
                <div style="color: #000;margin-top: 5px;" v-if="currentQuestion.typeStr.includes('判断题')">
                  本题为判断题，请判断对错
                </div>
                <div style="color: #000;margin-top: 5px;" v-else>本题为选择题，请选择序号</div>
              </div>
              <div style="color: #008EFF;margin-right: 5px;"
                v-if="accuracyTxt && options.txt!=='错题库' && options.txt !== '模拟考试'">
                正确率：{{ accuracyTxt }}%
              </div>
              <div class="controls" @click="collect" v-if="options.txt !== '模拟考试'">
                <i :style="{color:!currentQuestion.collected?'':'#ff7070'}" style="font-size:22px;"
                  :class="!currentQuestion.collected?'el-icon-star-off':'el-icon-star-on'"> </i>
                <span :style="{color:!currentQuestion.collected?'':'#ff7070'}" class="u-margin-left-10">收藏</span>
              </div>
              <!-- <div v-if="options.txt === '精选题库' || options.txt === '错题库' " class="controls" @click="controls(1)" :style="{border:controlIndex==1?'1px solid #38A5FD':'1px solid #333'}">
                            <img :src="controlIndex==1? require('@/assets/images/ask_s_1.png'):  require('@/assets/images/ask_1.png')" style="width: 15px;height: 22px;" />
                            <span class="u-margin-left-20" :style="{color:controlIndex==1?'#38A5FD':'#333'}">技巧</span>
                          </div> -->
              <div v-if="options.txt === '精选题库' || options.txt === '错题库' " class="controls" @click="controls(1)"
                style="border: 1px solid #333;">
                <img
                  :src="controlIndex === 1? require('@/assets/images/ask_1.png'):  require('@/assets/images/ask_1.png')"
                  style="width: 15px;height: 22px;" alt="" />
                <span class="u-margin-left-10">技巧</span>
              </div>
              <div class="controls" @click="controls(2)" v-if="options.txt === '精选题库' || options.txt === '错题库'"
                :style="{border: controlIndex === 2 ? '1px solid #38A5FD' : '1px solid #333'}">
                <img
                  :src="controlIndex === 2 ? require('@/assets/images/ask_s_2.png') : require('@/assets/images/ask_2.png')"
                  style="width: 19px;height: 19px;" alt="" />
                <span class="u-margin-left-10" :style="{color: controlIndex === 2 ? '#38A5FD' : '#333'}">语音</span>
              </div>
              <div v-if="options.txt === '精选题库' || options.txt === '错题库'" class="controls" @click="controls(3)"
                :style="{border: controlIndex === 3 ? '1px solid #38A5FD' : '1px solid #333'}">
                <img
                  :src="controlIndex === 3 ? require('@/assets/images/ask_s_3.png') : require('@/assets/images/ask_3.png')"
                  style="width: 18px;height: 18px;" alt="" />
                <span class="u-margin-left-10" :style="{color: controlIndex === 3 ? '#38A5FD' : '#333'}">视频</span>
              </div>
              <div v-if="options.txt === '精选题库' || options.txt === '错题库'" class="controls" @click="controls(4)"
                :style="{border: controlIndex === 3 ? '1px solid #38A5FD' : '1px solid #333'}">
                <img
                  :src="controlIndex === 3 ? require('@/assets/images/ask_s_3.png') : require('@/assets/images/ask_3.png')"
                  style="width: 18px;height: 18px;" alt="" />
                <span class="u-margin-left-10" :style="{color: controlIndex === 3 ? '#38A5FD' : '#333'}">官方解释</span>
              </div>
            </div>
          </div>
          <div class="u-flex-1">
            <template v-if="options.txt === '精选题库' || options.txt === '错题库'">
              <el-checkbox v-model="isAnswers" v-if="options.txt === '精选题库' || options.txt === '错题库'">是否显示答案
              </el-checkbox>
              <el-checkbox v-model="isNext">是否自动下一题</el-checkbox>
            </template>
          </div>
          <div class="flex">
            <div class="flex flex-row-between">
              <el-button
                style="width: 8.75rem;height: 3.75rem;font-weight: 600;font-size: 1.5rem;color: #000;border: 0.15rem solid gray;"
                @click="prev">
                上一题
              </el-button>
              <el-button
                style="width: 8.75rem;height: 3.75rem;font-weight: 600;font-size: 1.5rem;color: #000;margin-left: 1.25rem;border: 0.15rem solid gray;"
                @click="submit(true)">下一题
              </el-button>
              <el-button
                style="width: 8.75rem;height: 3.75rem;font-weight: 600;font-size: 1.5rem;color: #000;margin-left: 1.25rem;border: 0.15rem solid gray;"
                @click="berfor_complete()" v-if="['分类练习','错题库','收藏题'].includes(this.options.txt) == false"> 交卷
              </el-button>
            </div>
          </div>
        </div>

        <!-- 题目图片区 -->
        <div v-if="currentQuestion.image" style="width: 100%;text-align: center;" :style="{
                             height: `${imageHeight}px`
                           }">
          <!-- 方式一，点击直接放大 -->
          <!--          <el-image :src="currentQuestion.image" @click="showImagePreview(currentQuestion.image)" @load="onImageLoaded"
            style="z-index: 999;height: 100%;"></el-image> -->
          <!-- 方式二，预览方式，带放大镜 -->
          <el-image :src="currentQuestion.image" :preview-src-list="[currentQuestion.image]"
            style="z-index: 999;height: 100%;" @load="onImageLoaded">
          </el-image>
        </div>
        <!-- 默认占位高度，避免结构混乱 -->
        <div v-else style="width: 100%;text-align: center;" :style="{
                             height: `${imageHeight}px`
                           }">

        </div>

      </div>
    </div>



    <!-- 错误解析弹窗 -->
    <div v-show="analysisShow">
      <div class="fangdajing">
        <div style="color: #fff;font-size: 1.875rem;text-align: center;margin: 1.25rem 0;padding: 0 1.875rem;">
          错题学习
        </div>
        <!--  -->
        <div>
          <div class="fangItem" style="padding: 1.25rem;font-size: 1.25rem;">
            <div style="background: #fff;padding: 1.25rem;">
              <div v-html="errorTips.title"></div>
              <div v-for="(item,index) in errorTips.options" :key="index" class="flex" style="cursor:pointer;">
                <div style="margin-right: 1.25rem;">
                  <div v-if="errorTips.type === 3" style="font-weight: 600;">
                    {{ item.sort === 'A' ? '√' : '×' }}
                  </div>
                  <div v-else>
                    {{ item.sort }}
                  </div>
                </div>
                <div style="height: 1.8rem;line-height: 1.8rem;" v-html="item.content"></div>
              </div>
            </div>

            <div style="text-align: center;margin-top: 0.1rem;">
              <img :src="errorTips.image" alt="">
            </div>

            <div style="background: #fff;padding: 1.25rem;margin-top: -0.3125rem;">
              <div style="font-size: 1.625rem;font-weight: 600;">
                <span>正确答案：
                  <span v-if="errorTips.type === 3">
                    {{ (errorTips.answer || '').trim() === '正确' ? '√' : '×' }}
                  </span>
                  <span v-else>{{ errorTips.answer }}</span>
                </span>
                <span style="margin-left: 1.875rem;">你的答案：
                  <span v-if="answerDetail.type === 3">
                    {{ answerDetail.result === 'A' ? '√' : '×' }}
                  </span>
                  <span v-else>
                    {{ answerDetail.result }}
                  </span>
                </span>
              </div>
              <div>
                <div
                  style="width: 6.25rem;height: 2.5rem;text-align: center;line-height: 2.5rem;margin: 1.25rem auto;border: 1px solid #7c7474;"
                  @click="clickXianShi">确定
                </div>
                <div style="text-align: center;color: #7c7474;">页面将在{{ timer }}秒后自动关闭,
                  返回考试主界面
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="u-margin-top-20 u-font-20  flex" v-show="xianshi">
            <div>技巧解析：</div>
            <div v-html="currentQuestion.parse" style="max-width:90%;" class="parseHtml"></div>
          </div> -->
    <el-dialog v-drag :close-on-click-modal="false" :visible.sync="dialogSkill" width="900px">
      <div v-html="currentQuestion.parse" style="max-width:90%;" class="parseHtml"></div>
    </el-dialog>
    <el-dialog v-drag :close-on-click-modal="false" :visible.sync="dialogSkill1" width="900px">
      <div v-html="currentQuestion.explain" style="max-width:90%;font-size: 20px;" class="parseHtml">
      </div>
    </el-dialog>


    <!-- 视频区域 -->
    <el-dialog v-dialogDrag :visible.sync="videoShow" width="80%" :before-close="closeVideo">
      <video controls style="width: 100%;" id="video" :src="video" controlslist="nodownload">
      </video>
    </el-dialog>

    <!-- 得分结果 -->
    <gradeDialog :dialogVisible='gradeShow' :typeTxt='options.txt' :list='list'></gradeDialog>
    <!-- 得分结果 -->
    <div v-show="jiaojuanShow">
      <div class="fangdajing">
        <div style="color: #fff;font-size: 1.875rem;text-align: center;margin: 1.25rem 0;padding: 0 1.875rem;">
          考试确认窗口
        </div>
        <div style="background-color: #fff;padding: 6rem 0 0 5rem;font-size: 24px;min-height: 20rem;">
          <div>操作提示：</div>

          <div v-if="options.txt=='模拟考试'">
            <div class="u-font-20 ">本次考试已答 <span
                style="margin: 0 0.5rem;color: red;font-size: 1.5rem;font-weight: 500;"> {{score.answerNum}}</span>题
            </div>
            <div class="u-font-20 ">本次考试未答 <span
                style="margin: 0 0.5rem;color: red;font-size: 1.5rem;font-weight: 500;"> {{score.unAnswerNum}}</span>题
            </div>
          </div>
          <div v-if="options.txt=='精选题库'">
            <div class="u-font-20 ">本次考试答对 <span
                style="margin: 0 0.5rem;color: red;font-size: 1.5rem;font-weight: 500;"> {{score.realNum}}</span>题</div>
            <div class="u-font-20 ">本次考试答错 <span
                style="margin: 0 0.5rem;color: red;font-size: 1.5rem;font-weight: 500;"> {{score.defaultNum}}</span>题
            </div>
          </div>

          <div>1.点击【确认交卷】，将提交考试成绩，考试结束</div>
          <div>2.点击【继续考试】，将关闭本窗口，继续考试!</div>
        </div>

        <div style="text-align: center;margin: 4rem 0 2.5rem 0;">
          <el-button @click="complete()">确认交卷</el-button>
          <el-button type="primary" @click="jiaojuanShow = false" style="margin-left: 2.5rem;">继续考试</el-button>
        </div>
      </div>
    </div>

    <!-- 图片预览遮罩层 -->
    <div v-if="isImagePreviewVisible" class="image-preview-mask" @click="hideImagePreview"></div>
    <!-- 图片预览容器 -->
    <div v-if="isImagePreviewVisible" @click="hideImagePreview" class="image-preview-container"
      style="width: 80rem;top:25%;left:15%;height: 40rem;text-align: center;">
      <img :src="previewImageUrl" alt="" style="height: 80%;" mode="widthFix">
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import gradeDialog from './components/gradeDialog.vue'
  import BaseCountDown from '../../components/base/baseCountDown/baseCountDown.vue'
  import BaseBack from '../../components/base/baseBack/baseBack.vue'

  export default {
    components: {
      BaseBack,
      BaseCountDown,
      gradeDialog,
    },
    data() {
      return {
        loaded: false, // 加载完成后改为true
        // marginTop: 27 + 'px',
        analysisShow: false, // 错题解析的弹窗 false
        answerDetail: {},
        fontSize: '',
        accuracyTxt: '',
        videoShow: false,
        dialogSkill: false,
        dialogSkill1: false,
        gradeShow: false, // false   true
        isAnswers: false,
        isNext: false,
        controlIndex: '',
        current: 0, //当前题目
        user: {},
        config: {},
        options: this.$store.state.pageParams,
        list: [],
        video: '',
        timer: 7,
        askObjectList: {},
        flash: false,

        windowWidth: 0,
        windowHeight: 0,

        imageHeight: 180, // 初始图片高度
        initialHeightSet: false, // 标记是否已设置初始高度

        // 图片预览
        isImagePreviewVisible: false,
        previewImageUrl: '',

        // 交卷弹窗
        jiaojuanShow: false,
        score: {
          grade: '',
          pass: '',
          realNum: 0,
          defaultNum: 0,
          answerNum: 0,
          unAnswerNum: 0
        },

        gridData: [

        ],
        CarTypeName:'',
        errorTips:{},   // 修复错题解析的弹窗时显示题目不匹配，把错题存储起来
      }
    },
    watch: {
      checkAskObject: {
        immediate: true,
        handler(v) {
          // var title=v.ask[v.swiperIndex].title;
          if (this.options.txt === '错题库') {
            if (v.ask.length) {
              let askObject = v.ask[v.swiperIndex]
              let result = v.ask[v.swiperIndex].resultArr
              let answers = v.ask[v.swiperIndex].answerArr
              // answers.forEach(item1 => {
              // 	askObject.options.filter(item => item.sort == item1)[0].isReal = 1; //找出正确答案
              // })
              result.forEach(item1 => {
                var arr = askObject.options.filter(item => item.sort === item1)[0]
                console.log(arr, 'arr')
                if (!arr.isChange) {
                  arr.isChange = true
                }
              })

              // 添加答案
              askObject.resultInfo = askObject

              askObject.read = true
              this.$forceUpdate()
            }
          }
        },
      },
      current(v) {
        this.flash = this.list[v].read
      },
    },
    mounted() {
      this.fontSize = this.font
      // 升级优化的字号
      let font_size = localStorage.getItem('FontSizeValue');
      if (font_size) {
        this.fontSize = font_size
      }

      // 监听窗口变化（渲染后执行）
      window.addEventListener('resize', this.updateWindowDimensions);

      // 使用nextTick确保DOM渲染完成后再计算尺寸
      this.$nextTick(() => {
        // 延迟执行，确保图片资源加载完成
        setTimeout(() => {
          this.setInitialImageHeight();
        }, 300);
      });

    },
    beforeMount() {
      // 在DOM渲染前计算宽高
      this.updateWindowDimensions();
    },
    beforeDestroy() {
      // 组件销毁前移除事件监听，防止内存泄漏
      window.removeEventListener('resize', this.updateWindowDimensions);
    },
    computed: {
      ...mapState(['font', 'carTypeParams', 'pageParams']),
      checkAskObject() {
        return {
          swiperIndex: this.current,
          ask: this.list,
        }
      },
      currentQuestion() {
        return this.list[this.current]
      },
      multiple() {
        return this.currentQuestion.type === 2
      },
      containerStyle() {
        return {
          // display: 'flex',
          // justifyContent: 'center',
          // alignItems: 'center',
          // transform: 'scale(0.95)',
          // transformOrigin: 'center', // 设置缩放原点为中心
          // minHeight: '100vh', // 确保容器至少占据整个视口高度
        };
      }
    },
    created() {
      this.CarTypeName = localStorage.getItem('CarTypeName');

      this.$nextTick(() => {
        // 禁用右键
        document.oncontextmenu = new Function('event.returnValue=false')
        // 禁用选择
        document.onselectstart = new Function('event.returnValue=false')
      })
      this.getInformation()
      this.getConfig()
      if (this.options) {
        this.getList()
        this.getTime()
      }
    },
    methods: {
      getScaleTransform(result) {
        // if (length >= 3) return 'scale(1.1)';
        // if (length >= 2) return 'scale(1.7)';
        // return 'scale(2)';
        // 判断题：对、错
        if (result.type === 3) {
          return 'scale(2)';
        }
        if (result.resultArr.length == 1) {
          return 'scale(1.4)';
        }
        return 'scale(1.2)';
      },
      clickItems(row) {
        console.log('row', row)
        if (row !== undefined) {
          this.current = row
        }

      },
      fetchData(obj) {
        let arr = [];
        let child = [];
        let line_num = 1;

        obj.forEach((item, index) => {
          child.push(index);
          if (child.length === 10) {
            // 创建一个新对象，将child中的10个index值分别赋给col1至col10
            const newItem = {
              title: line_num + '行',
            };

            // 动态生成col1至col10属性
            child.forEach((idx, colIndex) => {
              newItem['col' + (colIndex + 1)] = idx;
            });

            arr.push(newItem);
            line_num += 1;
            child = [];
          }
        });

        // 处理剩余不足10个的情况
        if (child.length > 0) {
          const newItem = {
            title: line_num + '行',
          };

          child.forEach((idx, colIndex) => {
            newItem['col' + (colIndex + 1)] = idx;
          });

          arr.push(newItem);
        }


        // 模拟2秒后加载更多数据
        // arr.push(
        // { title: '1行', col1: '1-1', col2: '1-2', col3: '1-3', col4: '1-4', col5: '1-5', col6: '1-6', col7: '1-7', col8: '1-8', col9: '1-9' },
        // { title: '2行', col1: '2-1', col2: '2-2', col3: '2-3', col4: '2-4', col5: '2-5', col6: '2-6', col7: '2-7', col8: '2-8', col9: '2-9' },
        // { title: '3行', col1: '3-1', col2: '3-2', col3: '3-3', col4: '3-4', col5: '3-5', col6: '3-6', col7: '3-7', col8: '3-8', col9: '3-9' },
        // { title: '4行', col1: '4-1', col2: '4-2', col3: '4-3', col4: '4-4', col5: '4-5', col6: '4-6', col7: '4-7', col8: '4-8', col9: '4-9' },
        // { title: '5行', col1: '5-1', col2: '5-2', col3: '5-3', col4: '5-4', col5: '5-5', col6: '5-6', col7: '5-7', col8: '5-8', col9: '5-9' },
        //   { title: '6行', col1: '6-1', col2: '6-2', col3: '6-3', col4: '6-4', col5: '6-5', col6: '6-6', col7: '6-7', col8: '6-8', col9: '6-9' },
        //   { title: '7行', col1: '7-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '8行', col1: '8-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '9行', col1: '9-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '10行', col1: '10-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '11行', col1: '11-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '12行', col1: '12-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '13行', col1: '13-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '14行', col1: '14-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '15行', col1: '15-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '16行', col1: '16-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        //   { title: '17行', col1: '17-1', col2: '7-2', col3: '7-3', col4: '7-4', col5: '7-5', col6: '7-6', col7: '7-7', col8: '7-8', col9: '7-9' },
        // );
        this.gridData = arr;
      },
      // 图片加载完成时调用
      onImageLoaded() {
        if (!this.initialHeightSet) {
          this.setInitialImageHeight();
        }
      },

      // 设置初始图片高度
      setInitialImageHeight() {
        if (this.initialHeightSet) return;

        this.initialWindowHeight = window.innerHeight;
        this.updateWindowDimensions();
        this.initialHeightSet = true;
      },

      // 更新窗口尺寸和图片高度
      updateWindowDimensions() {
        const currentHeight = window.innerHeight;
        const heightChange = currentHeight - this.initialWindowHeight;

        // 限制最小高度，避免图片过小
        this.imageHeight = Math.max(200, 180 + heightChange);
      },
      showImagePreview(imageUrl) {
        this.previewImageUrl = imageUrl;
        this.isImagePreviewVisible = true;
      },
      hideImagePreview() {
        this.isImagePreviewVisible = false;
      },
      /**
       * 收藏
       */
      collect() {
        this.axios
          .post('/user/collect', {
            id: this.options.txt === '收藏库' ? this.currentQuestion.questionId : this.currentQuestion.id,
          })
          .then(() => {
            this.$set(this.currentQuestion, 'collected', !this.currentQuestion.collected)
          })
      },
      checkAccuracy() {
        let ask = this.list
        let realNum = 0
        let lengthNum = 0
        ask.forEach(item => {
          if (item.resultInfo) {
            if (item.resultInfo.pass) {
              realNum++
            }
            if (item.resultInfo) {
              lengthNum++
            }
          }
        })

        this.accuracyTxt = ((realNum / lengthNum) * 100).toFixed(2)
      },
      // 获得倒计时
      async getTime() {
        console.log('this.options.txt', this.options.txt);

        if (['分类练习', '错题库', '收藏题'].includes(this.options.txt) == true) return;

        // 1. 添加重试机制
        const MAX_RETRIES = 3;
        let retryCount = 0;

        const fetchAndSetCountdown = async () => {
          try {
            this.isLoading = true;

            const res = await this.axios.post('/index/testConfig', {
              subject: this.options.subjectId,
              car_type: this.options.carId,
            });

            console.log('倒计时配置:', res.timeLong);

            // 2. 使用MutationObserver监听DOM变化
            await this.waitForComponentMount();

            // 3. 添加验证确保时间有效
            const seconds = Math.max(0, res.timeLong * 60);
            this.$refs.CountDown.seconds = seconds;
            console.log('设置倒计时秒数:', seconds);

            // 4. 显式启动倒计时
            if (typeof this.$refs.CountDown.start === 'function') {
              this.$refs.CountDown.start();
            }

            return true; // 成功标志
          } catch (error) {
            console.error(`尝试 ${retryCount + 1}/${MAX_RETRIES} 失败:`, error);
            return false;
          } finally {
            this.isLoading = false;
          }
        };

        // 5. 实现组件挂载监听
        this.waitForComponentMount = () => {
          return new Promise((resolve, reject) => {
            // 立即检查
            if (this.$refs.CountDown) {
              console.log('CountDown组件已挂载');
              return resolve();
            }

            // 创建MutationObserver监听DOM变化
            const observer = new MutationObserver((mutationsList) => {
              if (this.$refs.CountDown) {
                console.log('通过MutationObserver检测到CountDown组件挂载');
                observer.disconnect();
                resolve();
              }
            });

            // 开始监听
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });

            // 设置超时
            setTimeout(() => {
              observer.disconnect();
              if (this.$refs.CountDown) {
                resolve();
              } else {
                reject(new Error('CountDown组件挂载超时'));
              }
            }, 3000); // 3秒超时
          });
        };

        // 6. 执行重试逻辑
        while (retryCount < MAX_RETRIES) {
          const success = await fetchAndSetCountdown();
          if (success) break;
          retryCount++;
          await new Promise(resolve => setTimeout(resolve, 500 * retryCount)); // 指数退避
        }

        // 7. 最终检查
        if (!this.$refs.CountDown || !this.$refs.CountDown.seconds) {
          console.error('倒计时设置失败，已达到最大重试次数');
          this.showError('加载倒计时失败，请刷新页面');
        }
      },
      // 弹窗点击了确定
      clickXianShi() {
        this.analysisShow = false
        this.timer = 0 // 以免读秒错乱
      },

      /**
       * 选项被点击
       * @param index
       */
      onCaskClick(index) {
        const cask = this.currentQuestion.options[index]
        // 已读
        if (this.currentQuestion.read) return

        // 如果不是多选题 则清除答案
        if (this.currentQuestion.type !== 2) {
          this.currentQuestion.options.forEach(item => {
            item.selected = item.id === cask.id
          })
        } else {
          // 高亮
          cask.selected = !cask.selected
        }

        // 如果点了自动下一题
        if (this.isNext && this.currentQuestion.type !== 2) {
          // 自动提交并翻页
          this.submit(true)
        }
      },

      /**
       * 提交答案
       * @param {boolean} next 是否自动翻页
       */
      submit(next) {

        // 修复错题解析
        this.errorTips = this.list[this.current]
        console.log('当前错题', this.errorTips)

        // 如果已经提交过了 就不再提交
        if (this.currentQuestion.read) {
          this.next()
          return
        }

        const result = this.currentQuestion.options
          .filter(item => item.selected)
          .map(item => item.sort)

        // 没有选择直接跳题
        if (result.length < 1) {
          this.next()
          return
        }
        console.log('下一题', this.currentQuestion)

        //收藏题过来的如果继续使用this.currentQuestion.id会报错
        let question_id = this.currentQuestion.id
        if (this.options.txt === '收藏库') {
          question_id = this.currentQuestion.questionId
        }

        this.axios
          .post('/user/answer', {
            type: this.options.txt === '模拟考试' ? 1 : 2,
            id: question_id,
            options: this.currentQuestion.options,
            result: result.join(','),
            exercise_num: this.current,
            cate_id: this.options.id,
            car_type: this.options.carId,
            subject: this.options.subjectId,
          })
          .then(res => {
            this.flash = true
            this.currentQuestion.read = true
            this.currentQuestion.skill = true
            this.answerDetail = res
            console.log('后台错题返回结果', this.answerDetail)
            if (!res.pass) {
              if (this.options.txt === '模拟考试') {
                this.timer = 7
                this.analysisShow = true
                let auth_timer = setInterval(() => {
                  this.timer--
                  if (this.timer <= 0) {
                    this.analysisShow = false
                    clearInterval(auth_timer)
                  }
                }, 1000)
              }
            }

            // 添加答案
            this.$set(this.currentQuestion, 'resultInfo', res)

            this.checkAccuracy()

            if (next) {
              this.next()
            }
          })
      },
      /**
       * 上一题
       */
      prev() {
        if (!this.current) return
        this.current--
      },
      /**
       * 下一题
       */
      next() {
        if (this.list.length > this.current + 1) {
          this.current++
        }
      },
      /**
       * 完成考试前操作
       */
      berfor_complete() {
        this.score.realNum = 0
        this.score.defaultNum = 0
        this.score.answerNum = 0 //答题数量
        this.score.unAnswerNum = 0 //未答题数量
        this.list.forEach(item => {
          if (item.resultInfo) {
            this.score.answerNum++
            if (item.resultInfo.pass) {
              this.score.realNum++
            } else {
              this.score.defaultNum++
            }
          } else {
            this.score.unAnswerNum++
          }
        })
        this.jiaojuanShow = true
      },
      /**
       * 完成考试
       */
      complete() {
        this.jiaojuanShow = false
        this.gradeShow = true
      },
      /**
       * 获得并处理题目列表
       */
      async getList() {
        console.log('类型：', this.options)
        let list
        if (this.options.txt === '收藏库') {
          list = await this.axios.post('/user/collectList', {})
        }
        if (this.options.txt === '精选题库') {
          list = await this.axios
            .post('/user/question', {
              test_paper_id: this.options.id,
              subject: this.options.subjectId,
              car_type: this.options.carId,
            })
        }
        if (this.options.txt === '模拟考试') {
          list = await this.axios
            .post('/user/question', {
              subject: this.options.subjectId,
              car_type: this.options.carId,
            })
        }
        if (this.options.txt === '三力测试') {
          list = await this.axios
            .post('/user/question', {
              car_type: this.options.carId,
              subject: 7,
              type: '模拟考试'
            })
        }
        if (this.options.txt === '错题库') {
          list = await this.axios
            .post('/user/examMistake', {
              id: this.pageParams.id,
            })
        }
        if (this.options.txt === '分类练习') {
          list = await this.axios
            .post('/index/orderQuestion', {
              cate_id: this.options.id,
              limit: 10000,
              page: 1
            })
          list = list.data
        }
        // console.log('list类型', typeof(list))
        // console.log('list列表', list)

        this.list = list.map((item, index) => {
          item.read = false // 已读预留

          item.typeStr = item.title.slice(0, 5)
          item.title = (index + 1) + '.' + item.title.slice(5)

          // 处理关键字
          let regExpStr = item.keywords.map(text => text.replace('(', '（').replace(')', '）')).join(
            '|')
          if (regExpStr) {
            let regExp = new RegExp(`(${regExpStr})`, 'ig')

            // 处理题目
            item.title = '<span>' +
              item.title.replace(regExp, '<span class="keyword">$1</span>') +
              '</span>'

            // 处理答案
            item.options.forEach(answerOption => {
              // 答案被选中
              answerOption.selected = false
              if (item.answers.map(i => +i).includes(+answerOption.id)) {
                // 如果是正确答案，则处理
                answerOption.content = '<span>' +
                  answerOption.content
                  .replace(regExp, '<span class="keyword">$1</span>') +
                  '</span>'
              } else {
                // 否则直接套span
                answerOption.content = '<span>' + answerOption.content + '</span>'
              }
            })
          } else {
            // 如果没有关键字，则直接套span
            item.title = '<span>' + item.title + '</span>'
            item.options.forEach(answerOption => {
              // 答案被选中
              answerOption.selected = false
              answerOption.content = '<span>' + answerOption.content + '</span>'
            })
          }

          return item
        })

        // 整理九宫格数据
        this.fetchData(this.list);

        this.loaded = true // 加载完成
      },

      async getInformation() {
        this.user = await this.axios.post('/user/information')
      },
      async getConfig() {
        this.config = await this.axios.post('/index/getConfig')
      },
      controls(e) {
        this.flash = true
        switch (e) {
          case 1:
            this.dialogSkill = true
            this.list[this.current].skill = !this.list[this.current].skill
            this.audio(this.currentQuestion.parseAudio, this.controlIndex, e)
            break
          case 2:
            this.audio(this.currentQuestion.titleAudio, this.controlIndex, e)
            break
          case 3:
            if (!this.currentQuestion.video) {
              this.$message({
                showClose: true,
                message: '暂无视频',
                type: 'warning',
              })
              return
            }
            this.$nextTick(() => {
              this.video = this.currentQuestion.video
              this.videoShow = true
            })
            break
          case 4:
            this.dialogSkill1 = true
            this.list[this.current].skill = !this.list[this.current].skill
            break
        }
      },
      audio(audio, ing, index) {
        const $audio = document.getElementById('successpay')
        if (ing) {
          $audio.pause()
          this.controlIndex = ''
          return
        }
        $audio.src = audio
        this.controlIndex = index
        $audio.play()
        $audio.onended = () => {
          this.controlIndex = ''
        }
      },
      closeVideo() {
        this.videoShow = false
        let myVideo = document.getElementById('video') //对应video标签的ID
        myVideo.pause()
      },
    },
  }
</script>

<style lang="scss">
  /* 新增：确保 html/body 无默认边距且高度占满 */
  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
    /* 禁止页面整体滚动（避免全屏时出现滚动条留白） */
  }

  .container {
    background-color: #f0f0f0;
    min-height: 100vh;
    /* 改用 vh 单位，强制与视口高度一致 */
    height: 100%;
    /* 补充高度属性，避免内容不足时出现空白 */
    overflow-y: auto;
    /* 允许容器内部滚动（替代 body 滚动） */
  }

  .page {
    background-color: #f0f0f0;
    min-height: 100vh;
    /* 设置最小高度为视口高度 */
  }

  // 新增内容：让内容居中的样式
  .pages {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f0f0f0;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  .blockss {
    height: 45px;
    line-height: 45px;
    min-width: 90px;
    text-align: center;
    background: #38a5fd;
    color: #fff;
    font-size: 20px;
    border-radius: 10px;
    margin-right: 20px;
    display: inline-block;
    cursor: pointer;
  }

  .parseHtml h2 {
    margin: 0 !important;
  }

  .parseHtml {
    padding: 20px;
  }

  .fangdajing {
    position: absolute;
    background-color: #1d75df;
    width: 81.25rem;
    top: 6.25rem;
    left: 16.25rem;
    box-shadow: rgba(0, 0, 0, 0.6) 0 0 0 100vw;
    z-index: 99999;
    padding: 0 1.25rem 1.25rem;
  }

  // 图片放大
  .image-preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }

  .image-preview-container {
    position: fixed;
    z-index: 10000;
    overflow: auto;
  }

  // 图片放大

  .fangItem p span {
    color: #000 !important;
  }

  .el-dialog__header {
    padding: 0 0;
  }

  .el-dialog__body {
    padding: 0 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }

  .el-image-viewer__mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.2;
    background: #000;
  }

  .el-popup-parent--hidden {
    overflow: hidden;
    padding-right: 0 !important;
  }

  .controls {
    border-radius: 10px;
    border: 1px solid #333333;
    text-align: center;
    margin-right: 15px;
    display: flex;
    align-items: center;
    padding: 10px 15px;
    cursor: pointer;
  }

  .selectblock {
    display: block;
    width: 3.3rem;
    height: 3.3rem;
    line-height: 3.3rem;
    text-align: center;
    border: 1px solid #707070;
    cursor: pointer;
    margin-left: 0.625rem;
  }

  .changes {
    background: #3cb4fe;
    border: 1px solid #3cb4fe;
    color: #fff;
  }

  .table {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 470px;
  }

  .liBclo {
    background-color: #81b6ef;
    text-align: center;
    line-height: 45px;
  }

  .liBclo1 {
    width: 38px;
    height: 46px;
    border-top: 1px solid #666;
    border-left: 1px solid #666;
  }

  .liBclo1:last-child {
    height: 45px;
    border-bottom: 1px solid #666;
  }

  .table li {
    width: 44px;
    height: 46px;
    border: 1px solid #666;
    margin-left: -1px;
    margin-bottom: -1px;
    cursor: pointer;
  }

  .default {
    color: #333;
  }

  .success {
    color: #fe3c3c;
  }

  // 选错之后的提示字体闪烁
  .flash {
    .keyword {
      color: #fe3c3c;
      animation: breath 1s linear infinite;
    }
  }

  // 多选题字体颜色红，跳动颜色黑
  .multiple {
    color: #fe3c3c;

    &.flash {
      .keyword {
        color: black;
      }
    }
  }

  @keyframes breath {

    /* 动画开始时的不透明度 */
    from {
      opacity: 0.1;
      transform: scale(2);
    }

    /* 动画50% 时的不透明度 */
    50% {
      opacity: 1;
    }

    /* 动画结束时的不透明度 */
    to {
      opacity: 0.1;
    }
  }

  /* 隐藏WebKit内核浏览器的滚动条 */
  .scrollable-div::-webkit-scrollbar {
    display: none;
  }

  .grid-container {
    width: 100%;
    max-width: 800px;
    height: 472px;
    min-height: 472px;
    border: 1px solid #999;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;
  }

  .grid-header {
    display: flex;
    background-color: #f0f0f0;
    font-weight: 500;
    border-bottom: 2px solid #999;
    flex-shrink: 0;
  }

  .grid-body {
    flex-grow: 1;
    overflow-y: auto;
    padding-bottom: 1px;
  }

  .grid-row {
    display: flex;
    border-bottom: 1px solid #999;
    height: 42px;
    align-items: center;

  }

  .hide-content {
    color: transparent !important;
    /* 让文字透明 */
    background-color: transparent !important;
    /* 让背景透明 */
    cursor: default !important;
    background-color: #fff !important;
  }

  .grid-cell {
    flex: 1;
    text-align: center;
    border-right: 1px solid #999;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
    height: 100%;
    /* 确保单元格高度占满整行 */
    display: flex;
    /* 使用flex布局 */
    align-items: center;
    /* 内容垂直居中 */
    justify-content: center;
    /* 内容水平居中 */
  }

  .grid-cell:last-child {
    border-right: none;
  }

  .title-cell {
    flex: 1.2;
    background-color: #81b6ef;
    font-weight: 500;
  }

  .header-cell {
    height: 42px;
    background-color: #81b6ef;
  }

  /* 新增：标题列底部网格线 */
  .grid-border-bottom {
    box-sizing: border-box;
    border-bottom: 1px solid #999;
  }

  .grid-row:last-child .grid-border-bottom {
    border-bottom: none;
    /* 最后一行不需要底部边框 */
  }

  /* 鼠标悬停效果 */
  .hover-cell {
    cursor: pointer;
    /* 显示手指光标 */
    transition: background-color 0.2s;
  }

  .hover-cell:hover {
    background-color: #55aaff;
    /* 浅蓝色背景 */
  }

  /* 美化滚动条 */
  .grid-body::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  .grid-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  .grid-body::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  .grid-body::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
  }

  /* 悬停效果 */
  .grid-row:hover {
    background-color: #f9f9f9;
    transition: background-color 0.2s;
  }
</style>



// WEBPACK FOOTER //
// src/pages/case/index.vue